<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/sellerDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/sellerProductsList/">Products</a></li>
      <li class="breadcrumb-item active" aria-current="page">Inventory View</li>
    </ol>
  </nav>
  <h1 class="d-block d-sm-none mb-3">Inventory</h1>
  <form>
    <div class="row mt-3">
      <div class=" col text-right" style="height: 27px;">
        <div class="form-group mb-2">
          <button type="submit" (click)="editProductSelect(productView)" class="btn btn-orange ml-2"
                  [disabled]="!(productView.productId || productView.id)">Edit Product
          </button>
        </div>
      </div>
    </div>
    <div id="productSection">
      <div class="row mt-3">
        <div class="col-lg-12">
          <div class="inner-box">
            <h2 class="text-black d-inline-block">Basic Product Information</h2>
            <div class="form-group required d-inline-block float-right" *ngIf="user.role !== 'ACCOUNT_OWNER'">
              <ngx-barcode [bc-value]="value" [bc-display-value]="false"></ngx-barcode>
            </div>
            <div class="row mt-4">
              <div class="col-lg-8 col-md-8">
                <div class="row">
                  <div class="col-md-4">
                    <label class="text-black mb-3"><b>Product Name : </b></label>
                    <label class="ml-1">{{productView.productName}}</label>
                  </div>
                  <div class="col-md-4">
                    <label class="text-black mb-3"><b>SKU : </b></label>
                    <label class="ml-1" style="text-transform:uppercase;" (cbOnSuccess)="copied($event)" ngxClipboard
                           [cbContent]="productView.sku">{{productView.sku}}</label>
                  </div>
                  <div class="col-md-4">
                    <label class="text-black mb-3"><b>Store SKU : </b></label>
                    <label class="ml-1" style="text-transform:uppercase;">{{productView.storeSku}}</label>
                  </div>
                </div>
                <div class="row">
                  <!--                                    <div class="col-md-4">
                                                          <label class="text-black mb-3"><b>Bar Code : </b></label>
                                                          <label class="ml-1">{{productView.barCode}}</label>
                                                      </div>-->
                  <div class="col-md-4">
                    <label class="text-black mb-3"><b>HSN Code : </b></label>
                    <label class="ml-1">{{productView.hsnCode}}</label>
                  </div>
                  <div class="col-md-4">
                    <label class="text-black mb-3"><b>Category : </b></label>
                    <label class="ml-1">{{productView.categoryName}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label class="text-black mb-3"><b>Product type : </b></label>
                    <label class="ml-1">{{productView.productType}}</label>
                  </div>
                </div>
              </div>

              <div class="col-4">
                <img class="d-md-none d-sm-none d-xs-none d-lg-block shift-uploaded-img"
                     src="{{productView.imageUrl !=null ? productView.imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                     width="250" height="250"
                />
                <!-- <img class="d-lg-none d-sm-none d-xs-none d-md-block shift-uploaded-img"
                     src="{{productView.imageUrl !=null ? productView.imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                     width="150" height="150"
                />
                <img class="d-lg-none d-md-none d-xs-none d-sm-block shift-uploaded-img"
                     src="{{productView.imageUrl !=null ? productView.imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                     width="100" height="100"
                />
                <img class="d-lg-none d-md-none d-sm-none d-xs-block shift-uploaded-img"
                     src="{{productView.imageUrl !=null ? productView.imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                     width="50" height="50"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--
            <div class="row mt-3" [hidden]="productView.productType === 'REGULAR'">
              <div class="col">
                <div class="inner-box">
                  <div>
                    <h2 class="text-black mb-3">Kit Component Details</h2>
                  </div>
                  <div class="row">
                    <div class="col-md-8">
                      <table class="table">
                        <thead>
                        <tr>
                          <th>SKU</th>
                          <th>Product Name</th>
                          <th>Quantity</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let p of productView.kitComponents;let i = index;">
                          <td style="text-transform:uppercase;">{{p.sku}}</td>
                          <td>{{p.productName}}</td>
                          <td>{{p.quantity}}</td>
                        </tr>
                        </tbody>
                      </table>
                      <hr>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      -->


      <div class="row mt-3" style="min-height: 325px;">
        <div class="col-lg-12">
          <ul class="list-inline tab-list">

            <li class="list-inline-item"><a (click)=" tabChange('attributes');"
                                            [ngClass]="{'active': tabClicked === 'attributes'}">Attributes</a></li>

            <li class="list-inline-item" *ngIf="productView.productType =='KIT'"><a (click)=" tabChange('component');"
                                                                                    [ngClass]="{'active': tabClicked === 'component'}">Components</a>
            </li>

            <!--<li class="list-inline-item"><a (click)=" tabChange('inventory');"
                                            [ngClass]="{'active': tabClicked === 'inventory'}">Stock Levels</a></li>-->

            <li class="list-inline-item" *ngIf="productView.productType !=='PackingMaterial'"><a
              (click)=" tabChange('fulfilment');"
              [ngClass]="{'active': tabClicked === 'fulfilment'}">Fulfilment Details</a>
            </li>

            <li class="list-inline-item"><a (click)=" tabChange('details');"
                                            [ngClass]="{'active': tabClicked === 'details'}">Orders</a></li>
          </ul>
          <div class="inner-box">

            <div class="" *ngIf="tabClicked == 'component'">
              <div>
                <h2 class="text-black mb-3">Kit Component Details</h2>
              </div>
              <div class="row">
                <div class="col-md-8">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Quantity</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let p of productView.kitComponents;let i = index;">
                      <td style="text-transform:uppercase;">{{p.sku}}</td>
                      <td>{{p.productName}}</td>
                      <td>{{p.quantity}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <hr>
                </div>
              </div>
            </div>

            <div class="row mt-3" *ngIf="tabClicked == 'attributes'">
              <div class="col-md-4">
                <label class="text-black mb-3"><b>Length (cm): </b></label>
                <label class="ml-1">{{productView.length}}</label>
              </div>
              <div class="col-md-4">
                <label class="text-black mb-3"><b>Width (cm): </b></label>
                <label class="ml-1">{{productView.width}}</label>
              </div>
              <div class="col-md-4">
                <label class="text-black mb-3"><b>Height (cm): </b></label>
                <label class="ml-1">{{productView.height}}</label>
              </div>
              <div class="col-md-4">
                <label class="text-black mb-3"><b>Weight (kg): </b></label>
                <label class="ml-1">{{productView.weight}}</label>
              </div>
              <!--   <div class="col-md-4" *ngIf="user.role !== 'ACCOUNT_OWNER'">
                   <label class="text-black mb-3"><b>Rack Location: </b></label>
                   <label class="ml-1">{{productView.rackLocation}}</label>
                 </div>
                 <div class="col-md-4" *ngIf="user.role !== 'ACCOUNT_OWNER'">
                   <label class="text-black mb-3"><b>Bin Location: </b></label>
                   <label class="ml-1">{{productView.binLocation}}</label>
                 </div>-->
              <div class="col-md-4">
                <label class="text-black mb-3"><b>Threshold Quantity: </b></label>
                <label class="ml-1">{{productView.minQuantity}}</label>
              </div>
              <div class="col-md-4">
                <label class="text-black mb-3"><b>Color : </b></label>
                <label class="ml-1">{{productView.productColor}}</label>
              </div>
              <div class="col-md-4">
                <label class="text-black mb-3"><b>Variant : </b></label>
                <label class="ml-1">{{productView.productVariant}}</label>
              </div>
            </div>
            <div class="row mt-3" *ngIf="tabClicked == 'inventory'">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                  <th>Warehouse Name</th>
                  <th>Quantity</th>
                  </thead>
                  <tbody>
                  <tr *ngFor="let p of productView.records">
                    <td class="">{{p.warehouseName}}</td>
                    <td class="">{{p.quantity}}</td>
                  </tr>
                  </tbody>
                </table>
                <hr>
              </div>
            </div>
            <div class="row mt-3" *ngIf="tabClicked == 'fulfilment'">
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="digitalProduct" [(ngModel)]="productAttr.digitalProduct"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="digitalProduct">This is a digital product</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="lotProduct" [(ngModel)]="productAttr.lotProduct"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="lotProduct">This is a lot product</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="dangerousGoods" [(ngModel)]="productAttr.dangerousGood"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="dangerousGoods">This is classified as dangerous goods</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="productNumberScans" [(ngModel)]="productAttr.productNumberScans"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="productNumberScans">This product requires serial number scans</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="wholeCaseProduct" [(ngModel)]="productAttr.wholeCaseProduct"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="wholeCaseProduct">This product should be picked as a whole case</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="fragileProducts" [(ngModel)]="productAttr.fragileProduct"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="fragileProducts">This product is fragile</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="foldableProduct" [(ngModel)]="productAttr.foldableProduct"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="foldableProduct">This product is foldable</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="BubbleMailer" [(ngModel)]="productAttr.bubbleMailer"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="BubbleMailer">Bubble Mailer</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="PolyMailer" [(ngModel)]="productAttr.PolyMailer"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="PolyMailer">Poly Mailer</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="form-group">
                  <div class="form-checkbox">
                    <input type="checkbox" id="essentialGoods" [(ngModel)]="productAttr.essentialGoods"
                           [ngModelOptions]="{standalone: true}" required disabled>
                    <label for="essentialGoods">Is an Essential Good</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3" *ngIf="tabClicked == 'details'">
              <div class="col">
                <div class="table-responsive" style="border: hidden!important;">
                  <table class="table">
                    <thead>
                    <tr>
                      <h2 class="text-black mb-3">Recent Activities</h2>
                    </tr>
                    <tr>
                      <th>SKU</th>
                      <th>ProductName</th>
                      <th>OrderNumber</th>
                      <th>OrderType</th>
                      <th>Quantity</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let pro of productView.historyActivities">
                      <td>{{pro.sku | replaceStatus}}
                      </td>
                      <td>{{pro.productName}}</td>
                      <td>{{pro.activityOrderNumber}}</td>
                      <td>{{pro.activityType | replaceStatus}}</td>
                      <td>{{pro.quantity}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <hr>
                </div>
              </div>
            </div>
            <br><br>
          </div>
        </div>
      </div>
    </div>


    <!--
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <h2 class="text-black mb-3">Recent Activities</h2>
            </tr>
            <tr>
              <th>Order Number</th>
              <th>Order Type</th>
              <th>Order Date</th>
              <th>Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let pro of productView.historyActivities">
              <td>{{pro.activityOrderNumber}}</td>
              <td>{{(pro.activityType == 'WORK_ORDER' ? 'Work Order' :
                (pro.activityType == 'STOCK' ? 'Stock' :
                  (pro.activityType == 'ORDER' ? 'Order' : "")))}}</td>
              <td>{{pro.createdDate}}</td>
              <td>{{pro.quantity}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div><br><br>
-->


    <!--<div class="row mt-3">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/inventories" class="btn btn-cancel">Close</button>
    </div>
  </div>-->
  </form>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" *ngIf="user.role ==='ROLE_ADMIN' || user.role ==='CUSTOMER_CARE'"
              routerLink="/admin/adminProducts" class="btn btn-cancel">
        Close
      </button>
      <button type="reset" *ngIf="user.role !=='WORK_MEN' && user.role !=='PACKER' && user.role ==='ACCOUNT_OWNER'"
              routerLink="/admin/inventories" class="btn btn-cancel">Close
      </button>
      <button type="reset" *ngIf="user.role =='WORK_MEN' || user.role =='PACKER'" routerLink="/admin/workMenOrder"
              class="btn btn-cancel">Close
      </button>
    </div>
  </div>
</div>
